/**
 * Function to score a search result based on the search query.
 * Query is what you wanted, found is what you got.
 *
 * @param {Object} searchResult object containing search result information
 * @param {String} queryString string containing the search query
 * @returns an integer score for the search result
 */
const scoreSearchResult = (foundString, queryString) => {
  // Regex to replace all characters that are not a space, hyphen, or alphanumeric with an empty string.
  const regex = /[^a-z0-9 -]/gi;

  // Normalize the strings by lowercasing and consider both spaces and hyphens as valid separators.
  const foundArray = foundString.replace(regex, '').toLowerCase().split(/-| /);
  const queryArray = queryString
    .replace(regex, '')
    .trim()
    .toLowerCase()
    .split(/-| /);

  let score = 0;

  // Allow a shift of up to the difference in length between the query and the found string.
  // This allows for the found string to be a substring of the query.
  // For example, if the query is "the quick brown fox" and the found string is "quick brown",
  let maximumShift = queryArray.length - foundArray.length;

  for (let i = 0; i < queryArray.length; i += 1) {
    for (let shift = 0; shift < maximumShift + 1; shift += 1) {
      if (!queryArray[i + shift] || !foundArray[i]) {
        continue;
      }

      if (queryArray[i + shift] === foundArray[i]) {
        // Exact single word match, 2 points.
        score += 2;
      } else if (foundArray[i].includes(queryArray[i + shift])) {
        // Partial match, 1 point.
        score += 1;
      } else if (queryArray[i + shift].includes(foundArray[i])) {
        // Partial match, 1 point.
        score += 1;
      }
    }
  }

  return score;
};

export default scoreSearchResult;
